"use client";

import { ReactNode } from "react";
import { useTelegramContext } from "@/contexts/TelegramContext";
import { clientConfig } from "@/lib/config/client-config";

/**
 * ConditionalRender - Platform-specific component renderer
 *
 * Automatically renders different components based on platform:
 * - TMA (Telegram Mini App): Uses Tailwind/shadcn components
 * - Web
 *
 * Both components must accept the same props interface for type safety.
 */
interface ConditionalRenderProps {
  tmaComponent: ReactNode;
  webComponent: ReactNode;
}

export const ConditionalRender = ({ tmaComponent, webComponent }: ConditionalRenderProps) => {
  const { isTMA } = useTelegramContext();

  return isTMA || clientConfig.tmaDev ? tmaComponent : webComponent;
};
